import Container from '@hellodarwin/core/lib/components/common/container';
import useMediaQuery from '@hellodarwin/core/lib/features/helpers/use-media-query';
import { useTheme } from 'styled-components';
import GrantsDirectoryTotal from '../../../../../../../../components/funding-explorer/grants-directory-total';
import useOnboardingFlow from '../../../../../../hooks/useOnboardingFlow';

interface OnboardingGrantsSuggestionsWrapperProps {
  children: React.ReactNode;
}
const OnboardingGrantsSuggestionsWrapper: React.FC<
  OnboardingGrantsSuggestionsWrapperProps
> = ({ children }) => {
  const { currentStepContent } = useOnboardingFlow();
  const { removeContainer } = currentStepContent ?? {};
  const theme = useTheme();
  const isMediumDesktop = useMediaQuery({ maxWidth: theme.breakpoints.l });
  if (isMediumDesktop) {
    return (
      <div style={{ minHeight: theme.fontsLineHeights.h5 }}>
        <GrantsDirectoryTotal elementTheme="h5" elementThemeMobile="h2" />
      </div>
    );
  }
  if (removeContainer) {
    return children;
  }
  return (
    <Container
      styles={{
        content: { overflow: 'auto', position: 'relative' },
      }}
      header={{
        label: (
          <div style={{ minHeight: theme.fontsLineHeights.h5 }}>
            <GrantsDirectoryTotal elementTheme="h5" />
          </div>
        ),
      }}
    >
      {children}
    </Container>
  );
};
export default OnboardingGrantsSuggestionsWrapper;
